import { getDecryptedCookie, setEncryptedCookie } from "../../utils/cookieUtils";

const SHOW_HOURS_COOKIE_KEY = "resourcePlannerShowHours";

/** Whether allocation hours are displayed, as remembered for the user in an encrypted cookie. Hours are shown unless "false" is stored. */
export const readShowHours = () => getDecryptedCookie(SHOW_HOURS_COOKIE_KEY) !== "false";

/** Remembers whether allocation hours are displayed. */
export const writeShowHours = (show) => setEncryptedCookie(SHOW_HOURS_COOKIE_KEY, String(show));
